import Http from '../utils/http'

// 获取侧边栏
export function getMenuList (params: unknown): any {
  return Http.get('/base/authority/get_menu_list', { params, timeout: 10000 })
}

// 获取验证码
export function getVerificationCode (params: unknown): any {
  return Http.get('/base/login/get_login_code', { params })
}

// 登入接口
export function getLogin (params: unknown): any {
  return Http.post('/base/user/login', params)
}

// 登出接口
export function getLoginOut (): any {
  return Http.post('/base/user/login_out')
}

// 当前登陆人信息
export function getUserInfo (): any {
  return Http.get('/base/authority/loginUserInfo')
}

// 获取水印图片
export function getWaterPng (): any {
  // 非登录状态下不能调用此接口
  if (location.href.includes('login')) {
    return {}
  } else {
    return Http.get('/base/waterPng', { timeout: 10000 })
  }
}
